module.exports = __webpack_public_path__ + "static/media/SaturdaySpecial2x.0f946178.png";